<h2 mat-dialog-title>Agencias</h2>
<mat-dialog-content class="mat-typography">
    <div class="contenedor-form" *ngIf="loading">
        <mat-spinner [diameter]="100" style="margin:0 auto; top:15px;"></mat-spinner>
      </div>
  <strong><p>Por favor seleccione las agencias a las que desea asignar el usuario</p></strong>
  <div class="row" *ngIf="!loading">
      <div class="col-s3 m3 l3"></div>
    <div class="col s6 m6 l6">
      <form [formGroup]="agenciaGroup">
      <mat-form-field>
            <mat-select (selectionChange)="setAgencias(selected)" placeholder="AGENCIAS" formControlName="formAgencias" multiple>                
              <mat-option *ngFor="let item of agencias" [value]="item.id">{{item.valor}}</mat-option>
            </mat-select>
          </mat-form-field>          
        </form>  
    </div>
    <div class="col-s3 m3 l3"></div>
  </div>
    
</mat-dialog-content>

<mat-dialog-actions align="end">  
  <button mat-raised-button color="primary" [disabled]="agenciasSet==''" [mat-dialog-close]="agenciasSet">Aceptar</button>  
</mat-dialog-actions>